<div class="tc-card br-card">
  <header class="tc-toolbar">
    <h2 class="tc-title">Users</h2>

    <div class="tc-search">
      <br-icon class="tc-search-icon">search</br-icon>
      <input type="search" autocomplete="off" placeholder="Search" [(ngModel)]="search" />
    </div>

    <button type="button" class="br-btn br-btn--ghost" *ngIf="auth.hasPermission('User.Manage')" (click)="openInviteUser()">
      <br-icon>mail</br-icon> Invite
    </button>
    <button type="button" class="br-btn br-btn--primary" *ngIf="auth.hasPermission('User.Manage')" (click)="openAddUser()">
      <br-icon>add</br-icon> New user
    </button>
  </header>

  <div class="tc-table-wrap">
    <table class="tc-table" *ngIf="filtered.length">
      <thead>
        <tr>
          <th class="sortable" (click)="sortBy('userName')">
            Name <span class="sort-ind" *ngIf="sortField === 'userName'">{{ sortDir === 'asc' ? '↑' : '↓' }}</span>
          </th>
          <th class="sortable" (click)="sortBy('email')">
            Email <span class="sort-ind" *ngIf="sortField === 'email'">{{ sortDir === 'asc' ? '↑' : '↓' }}</span>
          </th>
          <th class="sortable" (click)="sortBy('status')">
            Status <span class="sort-ind" *ngIf="sortField === 'status'">{{ sortDir === 'asc' ? '↑' : '↓' }}</span>
          </th>
          <th>Roles</th>
          <th class="col-actions"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let u of filtered; trackBy: trackById" class="row-click" (click)="goToDetail(u)">
          <td class="strong">{{ u.displayName || u.userName || '—' }}</td>
          <td class="muted">{{ u.emailAddress }}</td>
          <td>
            <span class="tag br-badge" [class.tag-muted]="!u.canLogin" [class.br-badge--neutral]="!u.canLogin">{{ u.canLogin ? 'Active' : 'Disabled' }}</span>
          </td>
          <td>
            <span class="role-chip br-badge br-badge--neutral" *ngFor="let r of visibleRoles(u.roles)">{{ r }}</span>
            <span class="role-chip role-chip-more br-badge" *ngIf="extraRoleCount(u.roles) > 0">+{{ extraRoleCount(u.roles) }}</span>
            <span class="muted" *ngIf="!u.roles.length">—</span>
          </td>
          <td class="col-actions col-actions-3">
            <button type="button" class="icon-btn br-btn br-btn--ghost br-icon-btn" title="Details" (click)="goToDetail(u); $event.stopPropagation()">
              <br-icon>visibility</br-icon>
            </button>
            <button type="button" class="icon-btn br-btn br-btn--ghost br-icon-btn" *ngIf="auth.hasPermission('User.Manage')"
                    [title]="u.canLogin ? 'Deactivate' : 'Reactivate'"
                    (click)="toggleActive(u); $event.stopPropagation()">
              <br-icon>{{ u.canLogin ? 'block' : 'check_circle' }}</br-icon>
            </button>
            <button type="button" class="icon-btn danger br-btn br-btn--ghost br-icon-btn" *ngIf="auth.hasPermission('User.Manage')"
                    title="Delete" (click)="deleteUser(u); $event.stopPropagation()">
              <br-icon>delete_outline</br-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="tc-empty" *ngIf="!loading && !filtered.length">
      <ng-container *ngIf="search">No users match “{{ search }}”.</ng-container>
      <ng-container *ngIf="!search">No users yet — add the first account to grant access.</ng-container>
    </div>

    <div class="tc-loading" *ngIf="loading">Loading…</div>
  </div>
</div>
